/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";
import colors from "assets/css/colors";
import actionButtonCss from "assets/css/actionButton.css";

const rightButtonCss = [
  actionButtonCss,
  css`
    color: ${colors.mainBlack};

    &:hover:not([disabled]) {
      background-color: ${colors.lightGrey};
      color: ${colors.mainBlack};
    }
  `,
];

const leftButtonCss = [
  rightButtonCss,
  css`
    transform: rotate(180deg);
  `,
];

export function buttonCss({ direction }) {
  return direction === "right" ? rightButtonCss : leftButtonCss;
}
